"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var R = require("ramda");
function epsExportImage(root) {
    return [
        "%!PS-Adobe-3.0 EPSF-3.0",
        "%%BoundingBox: 0 0 " + root.size.width + " " + root.size.height,
        "/ellipse {7 dict begin",
        "/endangle exch def",
        "/startangle exch def",
        "/yradius exch def",
        "/xradius exch def",
        "/yC exch def",
        "/xC exch def",
        "/savematrix matrix currentmatrix def",
        "xC yC translate",
        "xradius yradius scale",
        "0 0 1 startangle endangle arc",
        "savematrix setmatrix",
        "end",
        "} def"
    ].concat(R.unnest(root.components.map(function (c) { return epsExportComponent(c, root.size.height); }))).join("\n");
}
exports.epsExportImage = epsExportImage;
function epsExportComponent(c, height) {
    switch (c.type) {
        case "ellipse": {
            var cx = (c.topLeft.x + c.bottomRight.x) * 0.5;
            var cy = height - (c.topLeft.y + c.bottomRight.y) * 0.5;
            var rx = 0.5 * (c.bottomRight.x - c.topLeft.x);
            var ry = 0.5 * (c.bottomRight.y - c.topLeft.y);
            return getColored(c.fillColor, [
                cx + " " + cy + " " + rx + " " + ry + " 0 360 ellipse",
                "closepath",
                "fill"
            ]).concat(getColored(c.strokeColor, [
                cx + " " + cy + " " + rx + " " + ry + " 0 360 ellipse",
                "closepath",
                c.strokeThickness + " setlinewidth",
                "stroke"
            ]));
        }
        case "group": {
            return R.unnest(c.children.map(function (cc) { return epsExportComponent(cc, height); }));
        }
        case "line": {
            return getColored(c.strokeColor, [
                c.start.x + " " + (height - c.start.y) + " moveto",
                c.end.x + " " + (height - c.end.y) + " lineto",
                c.strokeThickness + " setlinewidth",
                "stroke"
            ]);
        }
        case "polygon": {
            return getColored(c.fillColor, [
                c.points[0].x + " " + (height - c.points[0].y) + " moveto"
            ].concat(c.points.map(function (p) { return p.x + " " + (height - p.y) + " lineto"; }), [
                "closepath",
                c.strokeThickness + " setlinewidth",
                "fill"
            ])).concat(getColored(c.strokeColor, [
                c.points[0].x + " " + (height - c.points[0].y) + " moveto"
            ].concat(c.points.map(function (p) { return p.x + " " + (height - p.y) + " lineto"; }), [
                "closepath",
                "stroke"
            ])));
        }
        case "polyline": {
            return getColored(c.strokeColor, [
                c.points[0].x + " " + (height - c.points[0].y) + " moveto"
            ].concat(c.points.map(function (p) { return p.x + " " + (height - p.y) + " lineto"; }), [
                c.strokeThickness + " setlinewidth",
                "stroke"
            ]));
        }
        case "rectangle": {
            var w = c.bottomRight.x - c.topLeft.x;
            var h = c.bottomRight.y - c.topLeft.y;
            return getColored(c.fillColor, [
                c.topLeft.x + " " + (height - c.bottomRight.y) + " " + w + " " + h + " rectfill"
            ]).concat(getColored(c.strokeColor, [
                c.strokeThickness + " setlinewidth",
                c.topLeft.x + " " + (height - c.bottomRight.y) + " " + w + " " + h + " rectstroke"
            ]));
        }
        case "text": {
            return getColored(c.textColor, [
                "gsave",
                "/" + c.fontFamily + " findfont",
                c.fontSize + " scalefont setfont",
                c.position.x + " " + (height - c.position.y) + " moveto",
                getTextXOffset(c),
                getTextYOffset(c),
                "rmoveto",
                -c.clockwiseRotationDegrees + " rotate",
                "(" + c.text + ") show",
                "grestore"
            ]);
        }
        default:
            return [];
    }
}
function getTextXOffset(c) {
    if (c.horizontalGrowthDirection === "left") {
        return "(" + c.text + ") stringwidth pop neg";
    }
    else if (c.horizontalGrowthDirection === "uniform") {
        return "(" + c.text + ") stringwidth pop neg 0.5 mul";
    }
    else {
        return "0";
    }
}
function getTextYOffset(c) {
    if (c.verticalGrowthDirection === "down") {
        return "gsave (" + c.text + ") true charpath pathbbox exch pop 3 -1 roll pop sub grestore";
    }
    else if (c.verticalGrowthDirection === "uniform") {
        return "gsave (" + c.text + ") true charpath pathbbox exch pop 3 -1 roll pop sub 0.5 mul grestore";
    }
    else {
        return "0";
    }
}
function getColored(color, instructions) {
    if (color.a === 0) {
        return [];
    }
    return [
        color.r / 255 + " " + color.g / 255 + " " + color.b / 255 + " setrgbcolor"
    ].concat(instructions);
}
//# sourceMappingURL=eps-export-image.js.map